import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetManagerPublicationsQueryResponse, GetManagerPublicationsQueryParams } from "../types/GetManagerPublications";

export const getManagerPublicationsQueryKey = (params: GetManagerPublicationsQueryParams) =>     [{url:`/api/ms-content-infoportal-backend/v1/admin/publications`},...(params ? [params] : [])] as const;
      export function getManagerPublicationsQueryOptions <TData = GetManagerPublicationsQueryResponse, TError = unknown>(params: GetManagerPublicationsQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getManagerPublicationsQueryKey(params);

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/ms-content-infoportal-backend/v1/admin/publications`,
              params,
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @link /api/ms-content-infoportal-backend/v1/admin/publications
 */

export function useGetManagerPublications <TData = GetManagerPublicationsQueryResponse, TError = unknown>(params: GetManagerPublicationsQueryParams, options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getManagerPublicationsQueryKey(params);

  const query = useQuery<TData, TError>({
    ...getManagerPublicationsQueryOptions<TData, TError>(params, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
